<template>
  <div>
    <vx-card
      title="Фильтры"
      class="p-1 mb-3 passes__filter-card"
      style="background: #e3e6fd"
      collapseAction
    >
      <div class="flex flex-wrap items-center justify-between w-full">
        <div class="header-filter md:w-2/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            :options="countItemsOmPage"
            :clearable="false"
            v-model="countElements"
            style="background-color: #fff"
            placeholder="Количество адресов"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </div>
    </vx-card>

    <vx-card :title="`Платные услуги | Всего ${totalServices}`" class="p-6">
      <vs-row class="mb-10">
        <vs-button @click="openPopupCreateService" color="primary"
          >Создать услугу</vs-button
        >
      </vs-row>
      <vs-table
        :data="services"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> Об услуге</vs-th>
          <vs-th> Сумма</vs-th>
          <vs-th> Даты</vs-th>
          <vs-th> Счет </vs-th>
          <vs-th> Статус </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].id }}
            </vs-td>

            <vs-td>
              <p class="mb-2">
                Название:
                <span class="text-primary">{{ data[indextr].name }}</span>
              </p>
              <p v-if="data[indextr].comment" class="mb-2">
                Комментарий:
                <span class="text-primary">{{ data[indextr].comment }}</span>
              </p>
            </vs-td>

            <vs-td>
              {{ data[indextr].amount }}
            </vs-td>

            <vs-td>
              <p class="mb-2">
                Дата создания:
                <span class="text-primary">{{
                  data[indextr].date_created
                }}</span>
              </p>
              <p class="mb-2">
                Оплатить до:
                <span class="text-primary">{{
                  data[indextr].date_pay_to
                }}</span>
              </p>
            </vs-td>

            <vs-td>
              <router-link
                v-if="data[indextr].invoice"
                :to="{
                  name: 'communal-payments-bill',
                  params: { id: data[indextr].invoice.id },
                }"
              >
                <span class="text-primary font-semibold">{{
                  data[indextr].invoice.id
                }}</span>
              </router-link>
            </vs-td>

            <vs-td>
              <span
                :class="{
                  'text-success': data[indextr].is_paid,
                  'text-danger': !data[indextr].is_paid,
                }"
              >
                {{ data[indextr].is_paid ? "Оплачено" : "Не оплачено" }}
              </span>
            </vs-td>

            <vs-td>
              <vx-tooltip class="inline-block" text="Открыть">
                <vs-button
                  :href="`/paid-services/${data[indextr].id}`"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-external-link"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>

    <vs-popup
      title="Новая платная услуга"
      :active.sync="activeCreateNewService"
      v-on:close="clearNewService"
    >
      <vs-input
        class="w-full mb-4"
        label="Название"
        name="Название"
        v-model="newService.name"
      />

      <vs-input
        class="w-full mb-4"
        label="Сумма"
        name="Сумма"
        type="number"
        v-model.number="newService.amount"
      />

      <label class="vs-input--label">Оплатить до</label>
      <flat-pickr
        class="block w-full"
        :config="configdateTimePickerFilter"
        v-model="newService.date_pay_to"
      />

      <vs-divider />

      <div class="flex flex-wrap items-center justify-between w-full">
        <div class="header-filter md:w-6/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterUsers"
            label="name"
            :options="userRole"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filterUsersList.user_role"
            placeholder="Роль пользователя"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-6/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterUsers"
            label="name"
            :options="countyType"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filterUsersList.homes__county_type"
            placeholder="Выбор поселения"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="ФИО"
            v-model="filterUsersList.full_name__icontains"
          />
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Телефон"
            v-model="filterUsersList.phone"
          />
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            v-model="filterUsersList.homes__homestead_number"
          />
        </div>
      </div>
      <vs-table
        v-model="selectedUser"
        @selected="handleSelected"
        :data="users"
        :stripe="false"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
        id="div-with-loading"
      >
        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> ФИО </vs-th>
          <vs-th> Адрес </vs-th>
          <vs-th> Статус </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td :data="data[indextr].full_name">
              {{ data[indextr].full_name }}
            </vs-td>

            <vs-td>
              <template v-if="data[indextr].in_consideration">
                <p class="mb-2">
                  Поселок:
                  <span class="text-primary">{{
                    data[indextr].county_type.name
                  }}</span>
                  <br />
                  Номер участка:
                  <span class="text-primary">{{
                    data[indextr].addresses[0]
                  }}</span>
                </p>
              </template>
              <template v-else>
                <p
                  v-for="(address, index) in data[indextr].homes"
                  :key="index"
                  class="mb-2"
                >
                  {{ index + 1 }}.
                  <span class="text-primary">{{
                    address.county_type.name
                  }}</span
                  >, участок #
                  <span class="text-primary">{{
                    address.homestead_number
                  }}</span
                  >, ул.
                  <span class="text-primary">{{ address.address }}</span>
                </p>
              </template>
            </vs-td>

            <vs-td>
              <template
                v-if="
                  data[indextr].is_confirmed && !data[indextr].in_consideration
                "
              >
                <span class="text-success">Одобрен</span>
              </template>
              <template
                v-else-if="
                  !data[indextr].is_confirmed && !data[indextr].in_consideration
                "
              >
                <span class="text-danger">Отклонен</span>
              </template>
              <template
                v-else-if="
                  !data[indextr].is_confirmed && data[indextr].in_consideration
                "
              >
                <span class="text-primary">На модерации</span>
              </template>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalUsersPagePagination"
        v-model="currentUsersPagingationPage"
      ></vs-pagination>

      <div class="popup-footer mt-4">
        <vs-button
          @click="createService"
          class="mr-5"
          type="relief"
          color="primary"
          :disabled="!validateCreateService"
          >Создать</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { API_URL, countItemsOmPage, countyType, userRole } from "@/.env";
import { DateTime } from "luxon";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

export default {
  data: () => ({
    BASE_URL: API_URL,
    services: [],

    filter: {},
    countElements: 20,

    currentPagingationPage: 1,
    totalServices: 0,
    totalPagePagination: 1,
    countItemsOmPage,

    activeCreateNewService: false,

    newService: {
      name: "",
      amount: 0,
      date_pay_to: "",
      user: null,
    },

    configdateTimePickerFilter: {
      enableTime: false,
      dateFormat: "d.m.Y",
      noCalendar: false,
      locale: RussianLocale,
    },

    /* Users */
    users: [],

    filterUsersList: {
      is_confirmed: true,
    },

    countUsersElements: 5,
    currentUsersPagingationPage: 1,
    totalUsers: 0,
    totalUsersPagePagination: 1,
    selectedUser: null,
    countyType,
    userRole,
  }),
  components: {
    DateTime,
    flatPickr,
  },
  watch: {
    filter: {
      handler(val) {
        this.filterServices();
      },
      deep: true,
    },
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getServices();
    },
    currentPagingationPage: function () {
      this.getServices();
    },

    /* Users */
    filterUsersList: {
      handler(val) {
        this.filterUsers();
      },
      deep: true,
    },
    currentUsersPagingationPage: function () {
      this.getUsers();
    },
  },
  computed: {
    validateCreateService() {
      return (
        !this.errors.any() &&
        this.newService.name !== "" &&
        this.newService.amount !== "" &&
        this.newService.date_pay_to !== "" &&
        (this.newService.user !== "") & (this.newService.user !== null)
      );
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    filterServices: _.debounce(function () {
      this.getServices();
    }, 500),
    getServices() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.paidServices.getServices(this.filter)).data;

        this.totalServices = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalServices / this.countElements
        );

        res.results.forEach((service) => {
          service.date_created = DateTime.fromISO(
            service.date_created
          ).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);

          service.date_pay_to = DateTime.fromFormat(
            service.date_pay_to,
            "yyyy-MM-dd"
          ).toFormat("dd.MM.yyyy");
        });

        this.services = res.results;
        this.$vs.loading.close();
      });
    },

    //Users
    handleSelected(user) {
      this.newService.user = user.id;
    },
    openPopupCreateService() {
      this.getUsers();
      this.activeCreateNewService = true;
    },

    filterUsers: _.debounce(function () {
      this.currentUsersPagingationPage = 1;
      this.getUsers();
    }, 500),

    getUsers() {
      this.$vs.loading();

      this.filterUsersList.page =
        this.currentUsersPagingationPage !== 1
          ? this.currentUsersPagingationPage
          : 1;
      this.filterUsersList.limit = this.countUsersElements;

      this.$load(async () => {
        let res = (await this.$api.users.getAllUsers(this.filterUsersList))
          .data;

        this.totalUsers = res.count;
        this.totalUsersPagePagination = Math.ceil(
          this.totalUsers / this.countUsersElements
        );

        res.results.forEach((user) => {
          user.county_type = countyType.find((x) => x.id == user.county_type);

          if (user.homes.length > 0) {
            user.homes.forEach((home) => {
              home.county_type = countyType.find(
                (x) => x.id == home.county_type
              );
            });
          }
        });

        this.users = res.results;
        this.$vs.loading.close();
      });
    },

    createService() {
      let payload = {
        name: this.newService.name,
        amount: this.newService.amount,
        date_pay_to: DateTime.fromFormat(
          this.newService.date_pay_to,
          "dd.MM.yyyy"
        ).toFormat("yyyy-MM-dd"),
        user: this.newService.user,
      };

      this.$load(async () => {
        await this.$api.paidServices
          .createService(payload)
          .then((response) => {
            this.notification("Успешно", "Платная услуга создана", "success");

            this.totalServices += 1;
            this.totalPagePagination = Math.ceil(
              this.totalServices / this.countElements
            );

            response.data.date_created = DateTime.fromISO(
              response.data.date_created
            ).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);

            response.data.date_pay_to = DateTime.fromFormat(
              response.data.date_pay_to,
              "yyyy-MM-dd"
            ).toFormat("dd.MM.yyyy");

            this.services.splice(0, 0, response.data);
            this.activeCreateNewService = false;
          })
          .catch(() => {
            this.notification(
              "Ошибка",
              "Не удалось создать Лицевой счет",
              "danger"
            );
          });
      });
    },
    clearNewService() {
      this.newService = {
        name: "",
        amount: 0,
        date_pay_to: "",
        user: null,
      };
    },
  },
  mounted() {
    this.getServices();
  },
};
</script>